import { getFetch, postFetch } from '../utils/request';
let requestUrl = ''
if(window.location.hostname.indexOf('gtarcade') > -1){
    requestUrl = (window.location.host.indexOf('localhost') > -1 || window.location.host.indexOf('qa') > -1 || window.location.host.indexOf('dev') > -1 || window.location.host.indexOf('prv') > -1) ? "https://qa-customer-robot.gtarcade.com" : "https://customer-robot.gtarcade.com";
} else {
    requestUrl = (window.location.host.indexOf('localhost') > -1 || window.location.host.indexOf('qa') > -1 || window.location.host.indexOf('dev') > -1 || window.location.host.indexOf('prv') > -1) ? "https://qa-customer-robot.youzu.com" : "https://customer-robot.youzu.com";
}

/** 
* @desc: 获取导航栏
*/ 

export async function getNavBar(data) {
    return getFetch(requestUrl + '/api/index/nav-bar', {}, true)
}

/**
* @desc: 获取初始化信息
*/ 


export async function getInitInfo(data) {
    return getFetch(requestUrl + '/api/index/init', data, true)
}


/** 
* @desc: 问题回复
* @param content 交互文案 默认 ''
*/ 

export async function charAnswer(data) {
    return getFetch(requestUrl + '/api/index/answer', data, true)
}

/** 
* @desc: 评价满意是否
* @param satisfied 点击是否满意 1满意 2不满意
*/ 

export async function evaluate(data) {
    return getFetch(requestUrl + '/api/index/satisfied', data, true)
}

/** 
* @desc: 获取底部导航栏
*/ 

export async function getBottomBar(data) {
    return getFetch(requestUrl + '/api/index/bot-bar', data, true)
}

/**
 * @navigation_type   问题类型
 * @id  id
 */ 
export async function clickNav(data) {
    return getFetch(requestUrl + '/api/index/click-nav', data, true)
}

/**
 * @navigation_type   问题类型
 * @id  id
 */ 
export async function clickBot(data) {
    return getFetch(requestUrl + '/api/index/click-bot', data, true)
}



/* old */
/**
 * @desc: 获取初始化数据
 */
export async function initData(data) {
    return getFetch(requestUrl + '/api/chat/init', {});
}

/**
 * @desc: 获取推荐问题列表
 * @param {type} cate_id 分类ID
 */
export async function getRecommend(data) {
    return getFetch(requestUrl + '/api/chat/recommend', {
        cate_id: data.cate_id
    });
}

/**
 * @desc: 用户输入问题
 * @param {type} question_id  问题ID 默认0
 * @param {type} content 问题内容
 */
export async function userChatAsk(data) {
    return postFetch(requestUrl + '/api/chat/ask', {
        question_id: 0,
        content: data.question,
    });
}

/**
 * @desc: 用户评价
 * @param {type} question_id  问题ID 默认0
 * @param {type} question 问题内容
 * @param {type} content 评价 1：好评 2：差评
 */
export async function userChatEvaluate(data) {
    return postFetch(requestUrl + '/api/chat/evaluate', {
        question_id: 0,
        question: data.question,
        comment: data.comment,
    });
}

/**
 * @desc: 获取问卷信息
 */
export async function getQuestionnaire(data) {
    return getFetch(requestUrl + '/api/chat/questionnaire', {});
}

/**
 * @desc: 问卷提交
 * @param {type} question_id  问题ID 默认0
 * @param {type} question 问题内容
 * @param {type} content 评价 1：好评 2：差评
 */
export async function questionnairePost(data) {
    return postFetch(requestUrl + '/api/chat/questionnaire-post', {
        question_id:  data.question_id,
        question: data.question,
        comment: data.comment,
        comment_content: data.comment_content,
    });
}